// extracted by mini-css-extract-plugin
export default {"error-stripe":"ActivateError_error-stripe__9E7p4"};